import React, { Component } from "react";

class ValidationTextArea extends Component {
  state = {
    hasError: false
  };
  constructor(props) {
    super(props);
    props.onBlur({ name: props.name, hasError: true });
  }
  componentDidMount() {
    if (this.props.defaultValue) {
      this.props.onBlur({ name: this.props.name, hasError: !this.validate(this.props.defaultValue) });
    }
  }
  validate = (value, otherClauseAuthorize) => {
    if (otherClauseAuthorize) { // user click Autre clause
      return value !== "";
    }else { // user click default clause
      return true
    }
  };
  handleOnEvent = (event, onEvent) => {
    const value = event.target.value;
    this.setState({ hasError: !this.validate(value, this.props.beneficiaireCapitalDecesOtherClauseAuthorize) });
    onEvent({ name: this.props.name, hasError: !this.validate(value, this.props.beneficiaireCapitalDecesOtherClauseAuthorize) }, event);
  };
  render() {
    const {
      defaultValue,
      onChange,
      name,
      onBlur,
      placeholder,
      type,
      rows,
      disabledEdit,
    } = this.props;
    const errorClass = "aps-section-register-fields-required";


    return (
      <div style={{width: "100%"}}>
        <textarea
          style={{overflowX: "hidden"}}
          className={`uk-textarea aps-section-register-fields ${
            this.state.hasError ? errorClass : ""
          }`}
          type={type}
          disabled={disabledEdit}
          placeholder={placeholder}
          name={name}
          rows={rows}
          defaultValue={defaultValue}
          onBlur={event => this.handleOnEvent(event, onBlur)}
          onChange={event => this.handleOnEvent(event, onChange)}
        />
        {this.state.hasError && (
          <p style={{marginBottom: "0px"}} className="uk-text-left aps-section-register-fields-required-alert">
              Veuillez saisir votre clause type
          </p>
        )}
      </div>
    );
  }
}
export default ValidationTextArea;



// WEBPACK FOOTER //
// ./src/components/ValidationTextarea/clauseType.js